module.exports = __webpack_public_path__ + "img/partido-morado.8a13cf08.png";